import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  HasDisplayName3s4kfsms5h38b as HasDisplayName,
} from '../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  sortedWith2csnbbb21k0lg as sortedWith,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { LineItem2rt64afaiyloc as LineItem } from '../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get__id219tqyp0nxml1 as get__id,
  get_started14uxkm9fjiknx as get_started,
} from '../../../../../crowpay-shared/com/crowpay/LineItemFields.mjs';
import { xDataClassPathInsideSet1u5agsol0s6ul as xDataClassPathInsideSet } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { ModificationBuilderuhgnvnxpchbi as ModificationBuilder } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/ModificationBuilder.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { MassModification2g7vooufrvzd as MassModification } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/MassModification.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { ReactiveMutableList2gg4x024enrbf as ReactiveMutableList } from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveMutableList.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  title1nssp3ryhwuqj as title,
  body3i5t0n7zprpqb as body,
  smallBody2trfy14zwtona as smallBody,
} from '../theming/Titles.mjs';
import { get_lightSection4cpu8okr0w14 as get_lightSection } from '../theming/sections.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { withSpacing5keoy85vrpk as withSpacing } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { scopeSetIcon1d64me82i5zfn as scopeSetIcon } from '../components/iconShortcuts.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText33v0vmsdeuehr as specCenteredText,
  get_textButtonybbt8y3eu5hx as get_textButton,
  specCenteredText1zemopd0g3rsf as specCenteredText_0,
} from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ItemClass;
function Item() {
  if (ItemClass === VOID) {
    class $ {
      constructor(lineItem) {
        this.iil_1 = lineItem;
      }
      g90() {
        return this.iil_1.l6k_1;
      }
      jil() {
        return listOf(this.iil_1.g6k_1);
      }
      k8v() {
        return this.iil_1.o6k_1;
      }
      toString() {
        return 'Item(lineItem=' + this.iil_1.toString() + ')';
      }
      hashCode() {
        return this.iil_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Item()))
          return false;
        if (!this.iil_1.equals(other.iil_1))
          return false;
        return true;
      }
    }
    protoOf($).f90 = get_shortDisplayName;
    initMetadataForClass($, 'Item', VOID, VOID, [HasDisplayName()]);
    ItemClass = $;
  }
  return ItemClass;
}
var ScopeClass;
function Scope() {
  if (ScopeClass === VOID) {
    class $ {
      constructor(scopeSet, lineIds) {
        this.kil_1 = scopeSet;
        this.lil_1 = lineIds;
      }
      jil() {
        return this.lil_1;
      }
      k8v() {
        return this.kil_1.o7z_1;
      }
      g90() {
        return this.kil_1.m7z_1;
      }
      toString() {
        return 'Scope(scopeSet=' + this.kil_1.toString() + ', lineIds=' + toString(this.lil_1) + ')';
      }
      hashCode() {
        var result = this.kil_1.hashCode();
        result = imul(result, 31) + hashCode(this.lil_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Scope()))
          return false;
        if (!this.kil_1.equals(other.kil_1))
          return false;
        if (!equals(this.lil_1, other.lil_1))
          return false;
        return true;
      }
    }
    protoOf($).f90 = get_shortDisplayName;
    initMetadataForClass($, 'Scope', VOID, VOID, [HasDisplayName()]);
    ScopeClass = $;
  }
  return ScopeClass;
}
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  // Inline function 'kotlin.collections.flatMap' call
  var tmp0 = $this.sil_1.ril_1;
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var list = element.jil();
    addAll(destination, list);
  }
  var ids = toSet(destination);
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var item = new (DataClassPathSelf())(tmp$ret$4);
  var tmp_1 = xDataClassPathInsideSet(get__id(item), ids);
  // Inline function 'com.lightningkite.lightningdb.modification' call
  // Inline function 'kotlin.apply' call
  var this_1 = new (ModificationBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
  var tmp$ret$9 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$9);
  var tmp_3 = get_started(it);
  // Inline function 'com.lightningkite.now' call
  var tmp$ret$11 = get_default(Companion_instance).d1m();
  this_1.e44(tmp_3, tmp$ret$11);
  var tmp$ret$15 = this_1.o1r();
  var tmp_4 = session.mfv_1.dek(new (MassModification())(tmp_1, tmp$ret$15), $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  // Inline function 'kotlin.collections.filter' call
  var tmp0_0 = $this.sil_1.nil_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList().w();
  var _iterator__ex2g4s_0 = tmp0_0.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    if (ids.t1(element_0.g6k_1)) {
      destination_0.v(element_0);
    }
  }
  var tmp_5 = $this.sil_1.pil_1(destination_0, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  get_dialogStack().ngd();
  return Unit_instance;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.til_1 = function_0;
      }
      wi(a, b) {
        return this.til_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.til_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
var StartWorkItemsDialog$_init_$slambda_y7avmfClass;
function StartWorkItemsDialog$_init_$slambda_y7avmf() {
  if (StartWorkItemsDialog$_init_$slambda_y7avmfClass === VOID) {
    class $ {
      mgy(it, $completion) {
        return Unit_instance;
      }
      s2(p1, $completion) {
        return this.mgy((!(p1 == null) ? isInterface(p1, KtList()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    StartWorkItemsDialog$_init_$slambda_y7avmfClass = $;
  }
  return StartWorkItemsDialog$_init_$slambda_y7avmfClass;
}
function StartWorkItemsDialog$_init_$slambda_y7avmf_0() {
  var i = new (StartWorkItemsDialog$_init_$slambda_y7avmf())();
  var l = (it, $completion) => i.mgy(it, $completion);
  l.$arity = 1;
  return l;
}
function StartWorkItemsDialog$options$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a instanceof Scope();
  var tmp$ret$1 = b instanceof Scope();
  return compareValues(tmp, tmp$ret$1);
}
var StartWorkItemsDialog$render$slambdaClass;
function StartWorkItemsDialog$render$slambda() {
  if (StartWorkItemsDialog$render$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    StartWorkItemsDialog$render$slambdaClass = $;
  }
  return StartWorkItemsDialog$render$slambdaClass;
}
function StartWorkItemsDialog$render$slambda_0() {
  var i = new (StartWorkItemsDialog$render$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function StartWorkItemsDialog$render$lambda(it) {
  return it.l6k_1;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var StartWorkItemsDialog$render$slambdaClass_0;
function StartWorkItemsDialog$render$slambda_1() {
  if (StartWorkItemsDialog$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.sil_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    StartWorkItemsDialog$render$slambdaClass_0 = $;
  }
  return StartWorkItemsDialog$render$slambdaClass_0;
}
function StartWorkItemsDialog$render$slambda_2(this$0) {
  var i = new (StartWorkItemsDialog$render$slambda_1())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var StartWorkItemsDialog$render$slambdaClass_1;
function StartWorkItemsDialog$render$slambda_3() {
  if (StartWorkItemsDialog$render$slambdaClass_1 === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    StartWorkItemsDialog$render$slambdaClass_1 = $;
  }
  return StartWorkItemsDialog$render$slambdaClass_1;
}
function StartWorkItemsDialog$render$slambda_4() {
  var i = new (StartWorkItemsDialog$render$slambda_3())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var StartWorkItemsDialogClass;
function StartWorkItemsDialog() {
  if (StartWorkItemsDialogClass === VOID) {
    class $ {
      constructor(project, items, scopes, onSubmit) {
        var tmp;
        if (onSubmit === VOID) {
          tmp = StartWorkItemsDialog$_init_$slambda_y7avmf_0();
        } else {
          tmp = onSubmit;
        }
        onSubmit = tmp;
        this.mil_1 = project;
        this.nil_1 = items;
        this.oil_1 = scopes;
        this.pil_1 = onSubmit;
        var tmp_0 = this;
        // Inline function 'kotlin.run' call
        var tmp0 = this.oil_1;
        // Inline function 'kotlin.collections.associateByTo' call
        var destination = HashMap().n8();
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp$ret$0 = element.k7z_1;
          destination.s3(tmp$ret$0, element);
        }
        var unusedScopes = destination;
        var options = ArrayList().w();
        var _iterator__ex2g4s_0 = this.nil_1.m1();
        $l$loop: while (_iterator__ex2g4s_0.n1()) {
          var item = _iterator__ex2g4s_0.o1();
          var tmp0_safe_receiver = item.k6k_1;
          var tmp_1;
          if (tmp0_safe_receiver == null) {
            tmp_1 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp0_safe_receiver_0 = unusedScopes.t3(tmp0_safe_receiver);
            var tmp_2;
            if (tmp0_safe_receiver_0 == null) {
              tmp_2 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.collections.filter' call
              var tmp0_0 = this.nil_1;
              // Inline function 'kotlin.collections.filterTo' call
              var destination_0 = ArrayList().w();
              var _iterator__ex2g4s_1 = tmp0_0.m1();
              while (_iterator__ex2g4s_1.n1()) {
                var element_0 = _iterator__ex2g4s_1.o1();
                if (equals(element_0.k6k_1, tmp0_safe_receiver)) {
                  destination_0.v(element_0);
                }
              }
              // Inline function 'kotlin.collections.map' call
              // Inline function 'kotlin.collections.mapTo' call
              var destination_1 = ArrayList().u(collectionSizeOrDefault(destination_0, 10));
              var _iterator__ex2g4s_2 = destination_0.m1();
              while (_iterator__ex2g4s_2.n1()) {
                var item_0 = _iterator__ex2g4s_2.o1();
                var tmp$ret$5 = item_0.g6k_1;
                destination_1.v(tmp$ret$5);
              }
              tmp_2 = options.v(new (Scope())(tmp0_safe_receiver_0, destination_1));
            }
            var tmp1_elvis_lhs = tmp_2;
            var tmp_3;
            if (tmp1_elvis_lhs == null) {
              continue $l$loop;
            } else {
              tmp_3 = tmp1_elvis_lhs;
            }
            tmp_1 = tmp_3;
          }
          if (tmp_1 == null)
            options.v(new (Item())(item));
        }
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp_4 = StartWorkItemsDialog$options$lambda;
        // Inline function 'kotlin.comparisons.thenBy' call
        var this_0 = new (sam$kotlin_Comparator$0())(tmp_4);
        var tmp_5 = (a, b) => {
          var previousCompare = this_0.compare(a, b);
          var tmp;
          if (!(previousCompare === 0)) {
            tmp = previousCompare;
          } else {
            // Inline function 'kotlin.comparisons.compareValuesBy' call
            var tmp_0 = a.k8v();
            var tmp$ret$14 = b.k8v();
            tmp = compareValues(tmp_0, tmp$ret$14);
          }
          return tmp;
        };
        var tmp$ret$16 = new (sam$kotlin_Comparator$0())(tmp_5);
        tmp_0.qil_1 = sortedWith(options, tmp$ret$16);
        this.ril_1 = ReactiveMutableList().uam(this.qil_1);
      }
      ud6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.tbo(StartWorkItemsDialog$render$slambda_0());
        view.eba(get_AppDimensions().wg1_1);
        var tmp = view.ibb(get_centered(view), view.hbb(DialogSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.eba(get_AppDimensions().wg1_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(true);
        title(view_1, this.mil_1.g7c_1 == null ? 'Start Work Items and Project?' : 'Start Work Items?');
        var tmp_0 = view_1.ibb(get_lightSection(view_1), sizeConstraints(view_1, VOID, VOID, get_rem(10), get_rem(50), VOID, get_rem(35)));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Frame())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_2.eba(get_AppDimensions().xg1_1);
        var tmp_1 = get_scrolling(view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.ebb(p_3, view_3);
        view_3.xbm(true);
        view_3.zb8(get_rem_0(0.5));
        var _iterator__ex2g4s = this.qil_1.m1();
        while (_iterator__ex2g4s.n1()) {
          var option = _iterator__ex2g4s.o1();
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (RowOrCol())(view_3.pc());
          var tmp0_elvis_lhs_4 = view_3.cbb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
          view_3.ebb(p_4, view_4);
          view_4.xbm(false);
          view_4.zb8(get_rem_0(0.5));
          var tmp_2 = get_centered(view_4);
          // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (Checkbox())(view_4.pc());
          var tmp0_elvis_lhs_5 = view_4.cbb_1;
          var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
          view_4.ebb(p_5, view_5);
          view_5.xah(view_5.cbk_1, this.ril_1.aan(option));
          view_4.fbb(p_5, view_5);
          view_4.jbb(tmp_2, view_5);
          var tmp_3 = get_expanding(view_4);
          var tmp_4;
          if (option instanceof Scope()) {
            // Inline function 'kotlin.collections.filter' call
            var tmp0 = this.nil_1;
            // Inline function 'kotlin.collections.filterTo' call
            var destination = ArrayList().w();
            var _iterator__ex2g4s_0 = tmp0.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element = _iterator__ex2g4s_0.o1();
              if (equals(element.k6k_1, option.kil_1.k7z_1)) {
                destination.v(element);
              }
            }
            var linesInScope = destination;
            var tmp_5 = withSpacing(view_4, 0.2);
            // Inline function 'com.lightningkite.kiteui.views.direct.col' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_6 = new (RowOrCol())(view_4.pc());
            var tmp0_elvis_lhs_6 = view_4.cbb_1;
            var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
            view_4.ebb(p_6, view_6);
            view_6.xbm(true);
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_7 = new (RowOrCol())(view_6.pc());
            var tmp0_elvis_lhs_7 = view_6.cbb_1;
            var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
            view_6.ebb(p_7, view_7);
            view_7.xbm(false);
            view_7.jbb(get_centered(view_7), scopeSetIcon(view_7, get_rem_0(0.8)));
            view_7.jbb(get_centered(view_7), body(view_7, option.g90()));
            view_7.jbb(get_centered(view_7), smallBody(view_7, '(' + option.lil_1.p1() + ' items)'));
            view_6.fbb(p_7, view_7);
            smallBody(view_6, joinToString(linesInScope, VOID, VOID, VOID, VOID, VOID, StartWorkItemsDialog$render$lambda));
            view_4.fbb(p_6, view_6);
            tmp_4 = view_4.jbb(tmp_5, view_6);
          } else {
            tmp_4 = view_4.jbb(get_centered(view_4), body(view_4, option.g90()));
          }
          view_4.jbb(tmp_3, tmp_4);
          view_3.fbb(p_4, view_4);
        }
        view_2.fbb(p_3, view_3);
        view_2.jbb(tmp_1, view_3);
        view_1.fbb(p_2, view_2);
        view_1.jbb(tmp_0, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_8 = view_1.cbb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_1 : tmp0_elvis_lhs_8;
        view_1.ebb(p_8, view_8);
        view_8.xbm(false);
        var tmp_6 = get_primaryButton(view_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (Button())(view_8.pc());
        var tmp0_elvis_lhs_9 = view_8.cbb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
        view_8.ebb(p_9, view_9);
        var tmp_7 = KMutableProperty0();
        var tmp_8 = Button$_get_enabled_$ref_61t7nx(view_9);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('enabled', 0, tmp_7, tmp_8, Button$_set_enabled_$ref_o8kynz(view_9));
        reactiveScope(view_9, ($this$reactiveScope) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          var tmp$ret$26 = !$this$reactiveScope.baj(this.ril_1).i1();
          this_0.set(tmp$ret$26);
          return Unit_instance;
        });
        specCenteredText(view_9, ($this$specCenteredText) => {
          var unit = $this$specCenteredText.baj(this.ril_1).p1() > 1 ? 'Work Items' : 'Work Item';
          return this.mil_1.g7c_1 == null ? 'Start ' + unit + ' & Project' : 'Start ' + unit;
        });
        onClick(view_9, VOID, VOID, StartWorkItemsDialog$render$slambda_2(this));
        view_8.fbb(p_9, view_9);
        view_8.jbb(tmp_6, view_9);
        var tmp_9 = get_textButton(view_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (Button())(view_8.pc());
        var tmp0_elvis_lhs_10 = view_8.cbb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
        view_8.ebb(p_10, view_10);
        specCenteredText_0(view_10, 'Go Back');
        onClick(view_10, VOID, VOID, StartWorkItemsDialog$render$slambda_4());
        view_8.fbb(p_10, view_10);
        view_8.jbb(tmp_9, view_10);
        view_1.fbb(p_8, view_8);
        view_0.fbb(p_1, view_1);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'StartWorkItemsDialog', VOID, VOID, [Page()]);
    StartWorkItemsDialogClass = $;
  }
  return StartWorkItemsDialogClass;
}
//region block: exports
export {
  StartWorkItemsDialog as StartWorkItemsDialogs82uh5psoxv6,
};
//endregion

//# sourceMappingURL=StartWorkItemsDialog.mjs.map
